// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3V9I1","type":"styles_type__1IIDZ","choices":"styles_choices__3zzrk"};